
import { Component, Vue } from 'vue-property-decorator'
import BacAlert from './BacAlert.vue'
import { Team } from '@/lib/models/Team'
import { User } from '@/lib/models/User'
import { LiabilityDisclaimer } from '@/lib/modules/liability/models/LiabilityDisclaimer'
import { Auth } from '@/middlewares/Auth'
import BacButton from './BacButton.vue'
import BacModal from './BacModal.vue'
import UIkit from 'uikit'
import { Http } from '@/lib/utils/Http'
import { Rally } from '@/lib/models/Rally'
import { SerializationHelper } from '../lib/utils/SerializationHelper'

@Component({
  components: {
    BacAlert,
    BacButton,
    BacModal
  }
})
export default class BacLiabilityDisclaimer extends Vue {
  members: User[] = []
  liabilityDisclaimers: LiabilityDisclaimer[] = []
  team: Team = new Team()
  rally: Rally = new Rally()

  get currentMember () {
    const token = Auth.getDecodedToken()
    return this.membersWithDisclaimerStatus.find(member => member.id === token.sub) || new User()
  }

  get currentMemberLiabilityDisclaimer () {
    const token = Auth.getDecodedToken()
    return this.liabilityDisclaimers.find(disclaimer => disclaimer.customerId === token.sub) || new LiabilityDisclaimer()
  }

  get membersWithDisclaimerStatus () {
    return this.members.map(member => {
      (member as any).liabilityStatus = !!this.liabilityDisclaimers.find(disclaimer => disclaimer.customerId === member.id)
      return member
    })
  }

  mounted () {
    this.loadTeamMembers()
    this.loadLiabilityDisclaimers()
  }

  async loadLiabilityDisclaimers () {
    this.liabilityDisclaimers = await LiabilityDisclaimer.getAll({ params: ['team', this.$route.params.id] })
  }

  async loadTeamMembers () {
    this.team = (await Team.getWithMembers(parseInt(this.$route.params.id)))
    this.members = this.team.members
    this.loadRally()
  }

  async loadRally () {
    const res = await Http.request(`/api/rally-round/${this.team.rallyRoundId}/rally`)
    this.rally = SerializationHelper.toInstance(new Rally(), await res.json())
  }

  async saveAccept () {
    await this.currentMemberLiabilityDisclaimer.create({
      params: ['team', this.$route.params.id]
    })
    await this.loadLiabilityDisclaimers()
    UIkit.modal('#disclaimer-modal').hide()
  }
}
